import React, {useEffect, useState} from 'react'
import {useHistory} from "react-router-dom";
import MaskedInput from 'react-input-mask'
import {Grid, Segment, Icon, Form, Header, Button, Modal, Dimmer, Loader} from "semantic-ui-react";
import Axios from "axios";
import {
    DateInput,
    TimeInput
} from 'semantic-ui-calendar-react';
import moment from "moment";
import objDefault from './../../../models/admissionModel'
import objDefaultValidate from './../../../models/admissionValidateModel'
import Constants from "./../../../config/constants";
import useStaff from "./../../../hooks/useStaff";
const eyes = [
    {key: 4, text: 'Spontaneous (4)', value: 4},
    {key: 3, text: 'To sound (3)', value: 3},
    {key: 2, text: 'To pressure (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT) ', value: 1}
]
const arrival = [
    {key: 1, text: 'Walk in', value: 1},
    {key: 2, text: 'EMS ออกรับ', value: 2},
    {key: 3, text: 'Refer จาก รพ.กระนวน', value: 3},
    {key: 4, text: 'Refer จาก รพ.น้ำพอง', value: 4},
    {key: 5, text: 'Refer จาก รพ.เขาสวนกวาง', value: 5},
    {key: 6, text: 'Refer จาก รพ.อุบลรัตน์', value: 6},
    {key: 7, text: 'Refer จาก รพ.ขอนแก่น', value: 7},
    {key: 8, text: 'Refer จาก อื่นๆ ....', value: 8}
]
const verbal = [
    {key: 5, text: 'Orientated (5)', value: 5},
    {key: 4, text: 'Confused (4)', value: 4},
    {key: 3, text: 'Words (3)', value: 3},
    {key: 2, text: 'Sounds (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT)', value: '1'}
]
const best = [
    {key: 6, text: 'Obey commands (6)', value: 6},
    {key: 5, text: 'Localizing (5)', value: 5},
    {key: 4, text: 'Normal flexion (4)', value: 4},
    {key: 3, text: 'Abnormal flexion (3)', value: 3},
    {key: 2, text: 'Extension (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT)', value: 1}
]

const options = [
    {key: 'm', text: 'ชาย', value: 'M'},
    {key: 'f', text: 'หญิง', value: 'F'}
]

const optionsBlood = [
    {key: 'a', text: 'A', value: 'A'},
    {key: 'b', text: 'B', value: 'B'},
    {key: 'ab', text: 'AB', value: 'AB'},
    {key: 'o', text: 'O', value: 'O'}
]
const option_drink = [
    {key: 'y', text: 'Yes', value: 'y'},
    {key: 'n', text: 'No', value: 'n'}
]
const option_normal_abnormal = [
    {key: 'y', text: 'unremarkable', value: 'unremarkable'},
    {key: 'n', text: 'Abnormal', value: 'Abnormal'}
]
const option_cspine_motion = [
    {key: 'y', text: 'Yes', value: 'Yes'},
    {key: 'n', text: 'No', value: 'No'}
]
const Admission = () => {
    const history = useHistory()
    const { staff } = useStaff();
    const [input, setInput] = useState({
        ...objDefault
    });
    const [inputText, setInputText] = useState({
        ...objDefaultValidate,
        text_head: 'เกิดข้อผิดพลาด',
        text_description: 'กรุณาติดต่อผู้ดูแลระบบ',
        text_error: [],

    });

    const [open, setOpen] = React.useState(false)
    const [users, setUsers] = useState([]);
    const [admissions, setAdmissions] = useState([]);
    const [admissionsList, setAdmissionsList] = useState([]);
    const [transactions, setTransactions] = useState({});
    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(false);

    const handleValueChange = (e) => {
        const {
            name, value
        } = e.target;
        setInput((prevInput) => ({
            ...prevInput,
            [name]: value,
        }))
        validateNumber(name,value)
    };
    useEffect(() => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('id')
        if (id) getAdmissionById(id)

    }, [inputText]);

    const handleValidate = () => {
        setInputText((prevInput) => ({
            ...prevInput,
            admission_date:!!!input.admission_date ? 'require' : false,
            discharge_date: !!!input.discharge_date ? 'require' : false,
            chief_complaint:!!!input.chief_complaint ? 'require' : false,
            // primary_a:!!!input.primary_a ? 'require' : false,
            // primary_b:!!!input.primary_b ? 'require' : false,
            // airway_managements:!!!input.breathing_managements ? 'require' : false,
            hr:!!!input.hr ? 'require' : false,
            pr:!!!input.pr ? 'require' : false,
            rr:!!!input.rr  ? 'require' : false,
            bp_d:!!!input.bp_d ? 'require' : false,
            bp_s:!!!input.bp_s ? 'require' : false,
            bt:!!!input.bt ? 'require' : false,
            sat:!!!input.sat ? 'require' : false,
         //   primary_c:!!!input.primary_c ? 'require' : false,
            active_bleeding:!!!input.active_bleeding ? 'require' : false,
           // managements:!!!input.managements ? 'require' : false,
            // inv_eFAST:!!!input.inv_eFAST ? 'require' : false,
            // inv_ekg:!!!input.inv_ekg? 'require' : false,
            gcs_e:!!!input.gcs_e ? 'require' : false,
            gcs_v:!!!input.gcs_v ? 'require' : false,
            gcs_m:!!!input.gcs_m ? 'require' : false,
            pupil_response:!!!input.pupil_response ? 'require' : false,
           // primary_e:!!!input.primary_e ? 'require' : false,
           //  pr2:!!!input.pr2 ? 'require' : false,
           //  ng_og_tube:!!!input.ng_og_tube ? 'require' : false,
           //  inv_p_cxr:!!!input.inv_p_cxr ? 'require' : false,
           //  abg:!!!input.abg ? 'require' : false,
            alcohol_history:!!!input.alcohol_history ? 'require' : false,
          //  medication:!!!input.medication ? 'require' : false,
          //  past_illness_pregnancy:!!!input.past_illness_pregnancy ? 'require' : false,
            events:!!!input.events ? 'require' : false,
            last_meal:!!!input.last_meal? 'require' : false,
            head_neck:!!!input.head_neck ? 'require' : false,
            heart_lungs:!!!input.heart_lungs ? 'require' : false,
            abdomen_pelvis:!!!input.abdomen_pelvis ? 'require' : false,
            extremities:!!!input.extremities ? 'require' : false,
            per_rectal_exam:!!!input.per_rectal_exam ? 'require' : false,
            neurologic:!!!input.neurologic ? 'require' : false,
            primary_diagnosis:!!!input.primary_diagnosis ? 'require' : false,
            other_problems:!!!input.other_problems ? 'require' : false,
            plan_of_managements:!!!input.plan_of_managements ? 'require' : false,
            restriction_cspine_motion:!!!input.restriction_cspine_motion ? 'require' : false,
         //   airway_managements:!!!input.airway_managements ? 'require' : false,
            fractures_deformities:!!!input.fractures_deformities ? 'require' : false,
          //  urethral_cath:!!!input.urethral_cath ? 'require' : false,
          //  allergy:!!!input.allergy ? 'require' : false,
            height: !!!input.height ? 'require' : false,
            weight: !!!input.weight ? 'require' : false,
            ward:!!!input.ward ? 'require' : false,
            staff_id :!!!input.staff_id? 'require' : false,
            resident_name :!!!input.resident_name ? 'require' : false,
            record_name :!!!input.record_name ? 'require' : false,
            recode_code :!!!input.recode_code ? 'require' : false,
            history:!!!input.history ? 'require' : false,
        }))

    }

    const validateNumber = (name,value) => {
        if (input.hr < 0 || (name ==='hr' && value < 0)) {
            setInput((prevInput) => ({
                ...prevInput,
                hr: 0
            }))
        }
        if (input.hr > 200 || (name ==='hr' && value > 200)) {
            setInput((prevInput) => ({
                ...prevInput,
                hr: 200
            }))
        }
        if (input.rr < 0 || (name ==='rr' && value < 0)) {
            setInput((prevInput) => ({
                ...prevInput,
                rr: 0
            }))
        }
        if (input.rr > 50 || (name ==='rr' && value > 50)) {
            setInput((prevInput) => ({
                ...prevInput,
                rr: 50
            }))
        }

        if ( input.bt < 25 && (input.bt).length > 1  || (name ==='bt' && value < 25 && (value).length > 1)) {
            console.log( (value).length)
            setInput((prevInput) => ({
                ...prevInput,
                bt: 25
            }))
        }
        if (input.bt > 45 || (name ==='bt' && value > 45)) {
            setInput((prevInput) => ({
                ...prevInput,
                bt: 45
            }))
        }

        if (input.sat < 0 || (name ==='sat' && value < 0)) {
            setInput((prevInput) => ({
                ...prevInput,
                sat: 0
            }))
        }
        if (input.sat > 100 || (name ==='sat' && value > 100)) {
            setInput((prevInput) => ({
                ...prevInput,
                sat: 100
            }))
        }

        if (input.bp_s < 0 || (name ==='bp_s' && value < 0)) {
            setInput((prevInput) => ({
                ...prevInput,
                bp_s: 0
            }))
        }
        if (input.bp_s > 250 || (name ==='bp_s' && value > 250)) {
            setInput((prevInput) => ({
                ...prevInput,
                bp_s: 250
            }))
        }

        if (input.bp_d < 0 || (name ==='bp_d' && value < 0)) {
            setInput((prevInput) => ({
                ...prevInput,
                bp_d: 0
            }))
        }
        if (input.bp_d > 250 || (name ==='bp_d' && value > 250)) {
            setInput((prevInput) => ({
                ...prevInput,
                bp_d: 250
            }))
        }


    }
    const search = async (e) => {
        setLoading(true);
        try {
            const {
                name, value
            } = e.target;
            setInput((prevInput) => ({
                ...prevInput,
                [name]: value,
            }))

            let res = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/patient?citizen_id=' + value,
                {
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    }
                });
            res = res.data.data[0]
            if (res && input.patient_found == false) {
                setInput((prevInput) => ({
                    ...prevInput,
                    name: res.name,
                    surname: res.surname,
                    address: res.address,
                    citizen_id: res.citizen_id,
                    gender: res.gender,
                    telephone: res.telephone,
                    email: res.email,
                    blood_group: res.blood_group,
                    rh: res.rh,
                    remark: res.remark,
                    hn: res.hn,
                    patient_id: res.id,
                    patient_found: true,
                    birth_date: moment(res.birth_date).format("DD-MM-YYYY"),
                }))
            }

            if (res === undefined && input.patient_found == true) {

                setInput((prevInput) => ({
                    ...prevInput,

                    patient_id: '',
                    patient_found: false
                }))
            }


        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    const navigateToBasket = (fullPath) => {
        history.push(fullPath);
    }

    const savePatient = async () => {
        try {
                let result = await Axios.post('http://' + Constants.url + ':' + Constants.port + '/v1/snr/patient',
                    {
                        name: input.name,
                        surname: input.surname,
                        address: input.address,
                        citizen_id: input.citizen_id,
                        gender: input.gender,
                        telephone: input.telephone,
                        email: input.email,
                        blood_group: input.blood_group,
                        rh: input.rh,
                        remark: input.remark,
                        patient_id: input.patient_id,
                        birth_date: input.birth_date,
                        validateInput : input,
                        hn : input.hn
                    },{
                        headers: {
                            Authorization: Constants.headerAuthorization,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                return result.data.data.id;

        } catch (e) {
            console.log(e)
        }
    }
    const saveAdmission = async () => {
        setLoading(true);
        try {
            handleValidate()
            let new_patient_id = await savePatient()
            if(!!!new_patient_id){
                setInputText((prevInput) => ({
                    ...prevInput,
                    text_head: 'เกิดข้อผิดพลาด',
                    text_description: 'กรุณาติดต่อผู้ดูแลระบบ',
                    text_error: []
                }))
                return  false
            }
            let result = await Axios.post('http://' + Constants.url + ':' + Constants.port + '/v1/snr/admission',
                {
                    id: input.id,
                    admission_date: input.admission_date,
                    patient_id: new_patient_id,
                    chief_complaint: input.chief_complaint,
                    primary_a: input.primary_a,
                    primary_b: input.primary_b,
                    breathing_managements: input.breathing_managements,
                    hr: input.hr,
                    rr: input.rr,
                    bp_s: input.bp_s,
                    bp_d: input.bp_d,
                    bt: input.bt,
                    sat: input.sat,
                    primary_c: input.primary_c,
                    heart_sound: input.heart_sound,
                    active_bleeding: input.active_bleeding,
                    managements: input.managements,
                    inv_eFAST: input.inv_eFAST,
                    inv_ekg: input.inv_ekg,
                    gcs_e: input.gcs_e,
                    gcs_v: input.gcs_v,
                    gcs_m: input.gcs_m,
                    pupil_response: input.pupil_response,
                    primary_e: input.primary_e,
                    spine_alignment: input.spine_alignment,
                    pr2: input.pr2,
                    ng_og_tube: input.ng_og_tube,
                    inv_p_cxr: input.inv_p_cxr,
                    abg: input.abg,
                    alcohol_history: input.alcohol_history,
                    medication: input.medication,
                    past_illness_pregnancy: input.past_illness_pregnancy,
                    events: input.events,
                    last_meal: input.last_meal,
                    head_neck: input.head_neck,
                    heart_lungs: input.heart_lungs,
                    abdomen_pelvis: input.abdomen_pelvis,
                    extremities: input.extremities,
                    per_rectal_exam: input.per_rectal_exam,
                    neurologic: input.neurologic,
                    remark_secondary_survey: input.remark_secondary_survey,
                    investigations: input.investigations,
                    primary_diagnosis: input.primary_diagnosis,
                    other_problems: input.other_problems,
                    plan_of_managements: input.plan_of_managements,
                    head_neck_remark: input.head_neck_remark,
                    heart_lungs_remark: input.heart_lungs_remark,
                    abdomen_pelvis_remark: input.abdomen_pelvis_remark,
                    extremities_remark: input.extremities_remark,
                    per_rectal_exam_remark: input.per_rectal_exam_remark,
                    neurologic_remark: input.neurologic_remark,
                    restriction_cspine_motion: input.restriction_cspine_motion,
                    airway_managements: input.airway_managements,
                    fractures_deformities: input.fractures_deformities,
                    urethral_cath: input.urethral_cath,
                    allergy: input.allergy,
                    weight: input.weight,
                    height: input.height,
                    ward: input.ward,
                    staff_name: input.staff_name,
                    resident_name: input.resident_name,
                    division: input.division,
                    record_name: input.record_name,
                    recode_code: input.recode_code,
                    record_datetime: input.record_datetime,
                    history: input.history,
                    active_bleeding_remark: input.active_bleeding_remark,
                    fractures_deformities_remark: input.active_bleeding_remark,
                    staff_id: input.staff_id,
                    arrival_station : input.arrival_station,
                    arrival_status : input.arrival_status,
                    birth_date : input.birth_date
                },{
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (result.data.message === 'Missing require field' || !!!new_patient_id) {

                setInputText((prevInput) => ({
                    ...prevInput,
                    text_head: 'เกิดข้อผิดพลาด',
                    text_description: result.data.message,
                    text_error: result.data.message_description
                }))
            } else {

                setInputText((prevInput) => ({
                    ...prevInput,
                    text_head: 'ทำรายการสำเร็จ',
                    text_description: result.data.data.message,
                    text_error : []
                }))

                setInput((prevInput) => ({
                    ...prevInput,
                    discharge_id: result.data.data.id,
                    id :result.data.data.id,
                }))
                getAdmissionById(result.data.data.id)

            }

            setOpen(true)

        } catch (e) {
            console.log(e)
            setOpen(true)
            setInputText((prevInput) => ({
                ...prevInput,
                text_head: 'เกิดข้อผิดพลาด',
                text_description: 'กรุณาติดต่อผู้ดูแลระบบ',
                text_error: []
            }))
        } finally {
            setLoading(false);
        }
    }

    function openInNewTab(id, path) {
        var win = window.open(path + id, '_blank');
        win.focus();
    }

    const navigateTo = (id, path) => {
        history.push(path + id);
    }

    const getUserById = async (user) => {
        try {
            let response = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/patient?id=' + user.patient_id,{
                headers: {
                    Authorization: Constants.headerAuthorization,
                    'Content-Type': 'application/json'
                }
            });
            response = response.data.data[0]
            setInput((prevInput) => ({
                ...prevInput,
                name: response.name,
                surname: response.surname,
                address: response.address,
                citizen_id: response.citizen_id,
                gender: response.gender,
                telephone: response.telephone,
                email: response.email,
                blood_group: response.blood_group,
                rh: response.rh,
                remark: response.remark,
                hn: response.hn,
                patient_id: response.id,
                birth_date:!!!response.birth_date ? null:moment(response.birth_date).format("DD-MM-YYYY"),
            }))

        } catch (e) {
            console.log(e);
        }
    }


    const getAdmissionById = async (id) => {
        setLoading(true);
        try {

            let response = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/admission?id=' + id,{
                headers: {
                    Authorization: Constants.headerAuthorization,
                    'Content-Type': 'application/json'
                }
            });
            response = response.data.data[0]
            getUserById(response)
            setInput((prevInput) => ({
                ...prevInput,
                name: response.name,
                surname: response.surname,
                address: response.address,
                citizen_id: response.citizen_id,
                gender: response.gender,
                id: id,
                admission_date: moment(response.admission_date).format("DD-MM-YYYY"),
                chief_complaint: response.chief_complaint,
                primary_a: response.primary_a,
                primary_b: response.primary_b,
                breathing_managements: response.breathing_managements,
                hr: response.hr,
                pr: response.pr,
                rr: response.rr,
                bt: response.bt,
                sat: response.sat,
                primary_c: response.primary_c,
                heart_sound: response.heart_sound,
                active_bleeding: response.active_bleeding,
                managements: response.managements,
                inv_eFAST: response.inv_eFAST,
                inv_ekg: response.inv_ekg,
                gcs_e: response.gcs_e,
                gcs_v: response.gcs_v,
                gcs_m: response.gcs_m,
                pupil_response: response.pupil_response,
                primary_e: response.primary_e,
                pr2: response.pr2,
                ng_og_tube: response.ng_og_tube,
                inv_p_cxr: response.inv_p_cxr,
                abg: response.abg,
                alcohol_history: response.alcohol_history,
                medication: response.medication,
                past_illness_pregnancy: response.past_illness_pregnancy,
                events: response.events,
                last_meal: response.last_meal,
                head_neck: response.head_neck,
                heart_lungs: response.heart_lungs,
                abdomen_pelvis: response.abdomen_pelvis,
                extremities: response.extremities,
                per_rectal_exam: response.per_rectal_exam,
                neurologic: response.neurologic,
                remark_secondary_survey: response.remark_secondary_survey,
                investigations: response.investigations,
                primary_diagnosis: response.primary_diagnosis,
                other_problems: response.other_problems,
                plan_of_managements: response.plan_of_managements,
                admission_id: response.admission_id,
                head_neck_remark: response.head_neck_remark,
                heart_lungs_remark: response.heart_lungs_remark,
                abdomen_pelvis_remark: response.abdomen_pelvis_remark,
                extremities_remark: response.extremities_remark,
                per_rectal_exam_remark: response.per_rectal_exam_remark,
                neurologic_remark: response.neurologic_remark,
                restriction_cspine_motion: response.restriction_cspine_motion,
                airway_managements: response.airway_managements,
                fractures_deformities: response.fractures_deformities,
                urethral_cath: response.urethral_cath,
                allergy: response.allergy,
                weight: response.weight,
                height: response.height,
                ward: response.ward,
                staff_name: response.staff_name,
                resident_name: response.resident_name,
                division: response.division,
                record_name: response.record_name,
                recode_code: response.recode_code,
                arrival_station : response.arrival_station,
                arrival_status : response.arrival_status,
                record_datetime: response.record_datetime ? moment(response.record_datetime).format("DD-MM-YYYY H:mm") : moment(new Date()).format("DD-MM-YYYY H:mm"),
                history: response.history,
                active_bleeding_remark: response.active_bleeding_remark,
                fractures_deformities_remark: response.active_bleeding_remark,
                bp_d: response.bp_d,
                bp_s: response.bp_s,
                staff_id: response.staff_id,


            }))


        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div style={{display: "flex", minHeight: "90vh", flexDirection: "column"}}>

                <div style={{flex: 1, position: 'relative'}}>
                    <Dimmer active={loading} inverted>
                        <Loader size='large'>กำลังโหลดข้อมูล...</Loader>
                    </Dimmer>
                    <Grid style={{marginTop: "5em", marginLeft: "2em"}}>
                        {
                            input.id ?
                                <>

                                    <Grid.Row>
                                        <Grid.Column width={8}>
                                            <Segment color='teal' raised>
                                                <Header as='h3' dividing>

                                                    <Button color='red'
                                                            onClick={() => openInNewTab(input.admission_id, '/admission/pdf?id=')}>
                                                        <Icon name={'file pdf'}></Icon> Admission note
                                                    </Button>
                                                    <Button color='teal'
                                                            onClick={() => navigateTo(input.admission_id, '/discharge?admission_id=')}>
                                                        <Icon name={'file alternate outline'}></Icon> Discharge summary

                                                    </Button>
                                                    <Button color='teal'
                                                            onClick={() => navigateTo(input.admission_id, '/opnote?admission_id=')}>
                                                        <Icon name={'clipboard'}></Icon> Operation note
                                                    </Button>
                                                    <Button color='teal'
                                                            onClick={() => navigateToBasket(`/basket?admission_id=${input.admission_id}&patient_id=${input.patient_id}`)}
                                                            key={input.admission_id}>
                                                        <Icon name={'image'}></Icon>Picture basket
                                                    </Button>

                                                </Header>
                                            </Segment>
                                        </Grid.Column>
                                    </Grid.Row>
                                </>
                                : ''
                        }
                        <Grid.Row>
                            <Grid.Column width={15}>
                                <Segment color='teal' raised

                                >
                                    <Form>
                                        <Form.Group widths='equal'>

                                            <Form.Input icon={'user'} fluid label='HN'

                                                        placeholder='HN'
                                                        children={
                                                            <MaskedInput
                                                                name='hn'
                                                                mask="aa9999"
                                                                value={input.hn}
                                                                placeholder="AZ-2789"
                                                                onChange={(e) => {
                                                                    handleValueChange(e);
                                                                }}
                                                            />
                                                        }
                                            />


                                            <Form.Input fluid label='ชื่อ' name='name' value={input.name}
                                                        placeholder='ชื่อ'
                                                        onChange={(e) => {
                                                            handleValueChange(e);
                                                        }}
                                                        error={input.name_error}


                                            />
                                            <Form.Input fluid label='นามสกุล' name='surname' value={input.surname}
                                                        placeholder='นามสกุล' error={input.surname_error} onChange={(e) => {
                                                handleValueChange(e)
                                            }}
                                            />
                                            <Form.Select
                                                fluid
                                                label='เพศ'
                                                name='gender'
                                                value={input.gender}
                                                options={options}
                                                placeholder='Gender'
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}

                                            />
                                            <Form.Input fluid label='เลขบัตรประชาชน' name='citizen_id'
                                                        value={input.citizen_id}
                                                        placeholder='บัตรประชาชน' error={input.citizen_error}
                                                        onChange={(e) => {
                                                            handleValueChange(e)
                                                        }}
                                                        onBlur={(e) => search(e)}
                                            />

                                        </Form.Group>
                                        <Form.Group widths='equal'>
                                            <DateInput
                                                width={'8'}
                                                name="birth_date"
                                                placeholder="Date"
                                                value={input.birth_date}
                                                label='วันเกิด'
                                                iconPosition="right"
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}

                                            />
                                            <Form.Input fluid label='เบอร์โทรศัพท์' width={'8'} name='telephone'
                                                        value={input.telephone}
                                                        placeholder='เบอร์โทรศัพท์' onChange={(e) => handleValueChange(e)}/>
                                            <Form.TextArea label='หมายเหตุ' placeholder='หมายเหตุ' name='remark'
                                                           value={input.remark} onChange={(e) => handleValueChange(e)}/>

                                        </Form.Group>

                                        <Form.Group widths='equal'>


                                        </Form.Group>


                                    </Form>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={15}>

                                <Segment color='teal' raised>
                                    <Header as='h3' block>
                                        HN {input.hn} ชื่อ {input.name} {input.surname} หมู่เลือด {input.blood_group} RH {input.rh}
                                    </Header>

                                    <Form>

                                        <Form.Group widths='equal'>
                                            <DateInput
                                                name="admission_date"
                                                placeholder="Date"
                                                value={input.admission_date}
                                                label='วันที่ admission'
                                                iconPosition="right"
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}
                                            />
                                            <Form.Select
                                                fluid label='Arrival status'
                                                name='arrival_status'
                                                value={input.arrival_status}
                                                options={arrival}
                                                placeholder='Arrival status'
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}

                                            />
                                            <Form.Input  fluid label='ชื่อ รพ.' name='arrival_station'
                                                        value={input.arrival_station}
                                                         disabled={input.arrival_status === 8 ? false:true}
                                                        placeholder='ชื่อ รพ.' onChange={(e) => handleValueChange(e)}
                                                        type={'text'}
                                            />
                                            <Form.Input required={'true'} fluid label='น้ำหนัก' name='weight'
                                                        value={input.weight}
                                                        placeholder='น้ำหนัก' onChange={(e) => handleValueChange(e)}
                                                        error={inputText.weight}
                                                        type={'number'}
                                            />
                                            <Form.Input required={'true'} fluid label='ส่วนสูง' name='height'
                                                        value={input.height}
                                                        placeholder='ส่วนสูง' onChange={(e) => handleValueChange(e)}
                                                        error={inputText.height}
                                                        type={'number'}
                                            />


                                        </Form.Group>

                                        <Form.Group widths='equal'>
                                            <Form.Input
                                                fluid label='Chief complaint'
                                                name='chief_complaint'
                                                value={input.chief_complaint}
                                                placeholder='Chief complaint'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.chief_complaint}
                                            />

                                        </Form.Group>
                                        <Header as='h3' dividing color='blue'>
                                            Primary Survey with Simultaneous Resuscitation
                                        </Header>
                                        <Form.Group widths='equal'>
                                            <Form.Input
                                                fluid label='History'
                                                name='history'
                                                value={input.history}
                                                placeholder='History'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.history}
                                            />

                                        </Form.Group>

                                        <Form.Group widths='equal'>
                                            <Form.TextArea
                                                fluid label=' Airway Assessment [A]'
                                                name='primary_a'
                                                value={input.primary_a}
                                                placeholder='Patent airway'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.primary_a}
                                            />

                                        </Form.Group>
                                        <Form.Group>
                                            <Form.TextArea
                                                width={14}
                                                fluid label=' Airway managements [A]'
                                                name='airway_managements'
                                                value={input.airway_managements}
                                                placeholder='None'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.airway_managements}
                                            />
                                            <Form.Select
                                                fluid
                                                width={4}
                                                label='Restriction of C-spine motion [A]'
                                                name='restriction_cspine_motion'
                                                value={input.restriction_cspine_motion}
                                                options={option_cspine_motion}
                                                placeholder='Restriction of C-spine motion [A]'
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}
                                                error={inputText.restriction_cspine_motion}
                                            />
                                        </Form.Group>


                                        <Form.Group widths='equal'>
                                            <Form.TextArea
                                                fluid label=' Breathing Assessment [B]'
                                                name='primary_b'
                                                value={input.primary_b}
                                                placeholder='Equal & normal breath sounds'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.primary_b}
                                            />

                                        </Form.Group>
                                        <Form.Group widths='equal'>
                                            <Form.TextArea

                                                fluid label='Breathing managements'
                                                name='breathing_managements'
                                                value={input.breathing_managements}
                                                placeholder='None'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.breathing_managements}
                                            />
                                        </Form.Group>
                                        <Form.Group widths='equal'>

                                            <Form.Input
                                                fluid label='HR/min'
                                                name='hr'
                                                type={'number'}
                                                value={input.hr}
                                                placeholder='HR'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.hr}

                                            />
                                            <Form.Input
                                                fluid label='RR/min'
                                                name='rr'
                                                type={'number'}
                                                value={input.rr}
                                                placeholder='rr'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.rr}
                                            />
                                            <Form.Input
                                                fluid label='Systolic BP'
                                                name='bp_s'
                                                value={input.bp_s}
                                                type={'number'}
                                                placeholder='Systolic BP'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.bp_s}
                                            />
                                            <Form.Input
                                                fluid label='Diastolic BP'
                                                name='bp_d'
                                                value={input.bp_d}
                                                type={'number'}
                                                placeholder='Diastolic BP'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.bp_d}
                                            />


                                            <Form.Input
                                                fluid label='BT (c.)'
                                                name='bt'
                                                value={input.bt}
                                                type={'number'}
                                                placeholder='BT (c.)'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.bt}
                                            />

                                            <Form.Input
                                                fluid label='Oxygen saturation  (%)'
                                                name='sat'
                                                value={input.sat}
                                                placeholder='SAT'
                                                type={'number'}
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.sat}
                                            />
                                        </Form.Group>

                                        <Form.TextArea
                                            fluid label=' Circulation [C] Abdomen'
                                            name='primary_c'
                                            value={input.primary_c}
                                            placeholder='Unremarkable'
                                            onChange={(e) => handleValueChange(e)}
                                            required={'true'}
                                            error={inputText.primary_c}
                                        />
                                        <Form.Group widths='equal'>

                                            <Form.Select
                                                fluid label='Active bleeding'
                                                name='active_bleeding'
                                                value={input.active_bleeding}
                                                options={option_cspine_motion}
                                                placeholder='Active bleeding'
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}

                                            />

                                            <Form.Select
                                                fluid label='Fractures/deformities'
                                                name='fractures_deformities'
                                                value={input.fractures_deformities}
                                                options={option_cspine_motion}
                                                placeholder='fractures_deformities'
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}

                                            />

                                        </Form.Group>
                                        <Form.Group widths='equal'
                                                    style={{display: (input.active_bleeding === 'Yes' ? '' : 'none')}}>

                                            <Form.TextArea
                                                fluid
                                                label={(<label style={{color: '#a5673f'}}>Active bleeding remark </label>)}
                                                name='active_bleeding_remark'
                                                value={input.active_bleeding_remark}
                                                placeholder='Active bleeding remark'
                                                onChange={(e) => handleValueChange(e)}

                                            />
                                        </Form.Group>
                                        <Form.Group widths='equal'
                                                    style={{display: (input.fractures_deformities === 'Yes' ? '' : 'none')}}>

                                            <Form.TextArea
                                                fluid
                                                label={(<label style={{color: '#a5673f'}}>Fractures/deformities
                                                    remark </label>)}
                                                name='fractures_deformities_remark'
                                                value={input.fractures_deformities_remark}
                                                placeholder='Fractures/deformities Remark '
                                                onChange={(e) => handleValueChange(e)}
                                            />
                                        </Form.Group>
                                        <Form.Group widths='equal'>
                                            <Form.TextArea

                                                fluid label='Circulation managements'
                                                name='managements'
                                                value={input.managements}
                                                placeholder='None'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.managements}
                                            />
                                        </Form.Group>
                                        <Form.Group widths='equal'>

                                            <Form.Input
                                                fluid label='eFAST'
                                                name='inv_eFAST'
                                                value={input.inv_eFAST}
                                                placeholder='Negative'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.inv_eFAST}
                                            />
                                            <Form.Input
                                                fluid label='EKG'
                                                name='inv_ekg'
                                                value={input.inv_ekg}
                                                placeholder='Sinus rhythm'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.inv_ekg}
                                            />

                                        </Form.Group>

                                        <Form.Group widths='equal'>
                                            <Form.Select
                                                fluid label='Eye opening (E)'
                                                name='gcs_e'
                                                value={input.gcs_e}
                                                placeholder='GSC eyes'
                                                options={eyes}
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}
                                                error={inputText.gcs_e}

                                            />

                                            <Form.Select
                                                fluid label='Verbal response (V)'
                                                name='gcs_v'
                                                value={input.gcs_v}
                                                placeholder='Verbal response (V)'
                                                options={verbal}
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}
                                                error={inputText.gcs_v}
                                            />

                                            <Form.Select
                                                fluid label='Motor response (M)'
                                                name='gcs_m'
                                                value={input.gcs_m}
                                                placeholder='Motor response (M)'
                                                options={best}
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}
                                                error={inputText.gcs_m}
                                            />
                                            <Form.Input
                                                fluid label='Pupil response'
                                                name='pupil_response'
                                                value={input.pupil_response}
                                                placeholder='Pupil response'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.pupil_response}
                                            />

                                        </Form.Group>
                                        <Form.Group widths='equal'>
                                            <Form.TextArea

                                                fluid label='Exposure/Environment control  [E]'
                                                name='primary_e'
                                                value={input.primary_e}
                                                placeholder='No other lesion'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.primary_e}
                                            />
                                        </Form.Group>

                                        <Form.Group widths='equal'>


                                            <Form.Input
                                                fluid label='Per-rectal examination'
                                                name='pr2'
                                                value={input.pr2}
                                                placeholder='Not done'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.pr2}
                                            />
                                        </Form.Group>
                                        <Header as='h3' dividing color='blue'>
                                            Adjuncts to the Primary Survey
                                        </Header>

                                        <Form.Group widths='equal'>
                                            <Form.Input

                                                fluid label='NG/OG tube'
                                                name='ng_og_tube'
                                                value={input.ng_og_tube}
                                                placeholder='Not done'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.ng_og_tube}
                                            />
                                            <Form.Input
                                                fluid label='Urethral cath'
                                                name='urethral_cath'
                                                value={input.urethral_cath}
                                                placeholder='Not done'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.urethral_cath}
                                            />

                                        </Form.Group>
                                        <Form.Group widths='equal'>
                                            <Form.Input

                                                fluid label='Portable chest X-ray'
                                                name='inv_p_cxr'
                                                value={input.inv_p_cxr}
                                                placeholder='Not done'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.inv_p_cxr}
                                            />
                                            <Form.Input
                                                fluid label='Arterial blood gas'
                                                name='abg'
                                                value={input.abg}
                                                placeholder='Not done'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.abg}
                                            />

                                        </Form.Group>
                                        <Header as='h3' dividing color='blue'>
                                            Secondary Survey
                                        </Header>

                                        <Form.Group widths='equal'>
                                            <Form.Input

                                                fluid label='Allergy'
                                                name='allergy'
                                                value={input.allergy}
                                                placeholder='None'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.allergy}

                                            />


                                            <Form.Select
                                                fluid
                                                width={8}
                                                label='ประวัติดื่มสุรา'
                                                name='alcohol_history'
                                                value={input.alcohol_history}
                                                options={option_drink}
                                                placeholder='ประวัติดื่มสุรา'
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}
                                                error={inputText.alcohol_history}
                                            />
                                            <Form.Input

                                                fluid label='Medication'
                                                name='medication'
                                                value={input.medication}
                                                placeholder='None'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.medication}

                                            />
                                            <TimeInput
                                                width={8}
                                                fluid label='Last meal'
                                                name='last_meal'
                                                value={input.last_meal}
                                                placeholder='Last meal'
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}
                                                error={inputText.last_meal}
                                            />


                                        </Form.Group>
                                        <Form.Group widths='equal'>
                                            <Form.TextArea

                                                fluid label='Past illness / Pregnancy'
                                                name='past_illness_pregnancy'
                                                value={input.past_illness_pregnancy}
                                                placeholder='None'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.past_illness_pregnancy}
                                            />
                                        </Form.Group>
                                        <Form.Group widths='equal'>
                                            <Form.TextArea

                                                fluid label='Events'
                                                name='events'
                                                value={input.events}
                                                placeholder='Events'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.events}
                                            />


                                        </Form.Group>

                                        <Form.Group widths='equal'>

                                            <Form.Select

                                                fluid label='Head - neck'
                                                name='head_neck'
                                                value={input.head_neck}
                                                placeholder='Head - neck'
                                                options={option_normal_abnormal}
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}
                                                error={inputText.head_neck}
                                            />
                                            <Form.Select
                                                fluid label='Heart - lungs'
                                                name='heart_lungs'
                                                value={input.heart_lungs}
                                                placeholder='Heart - lungs'
                                                options={option_normal_abnormal}
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}
                                                error={inputText.heart_lungs}
                                            />
                                            <Form.Select

                                                fluid label='Abdomen-pelvis'
                                                name='abdomen_pelvis'
                                                value={input.abdomen_pelvis}
                                                placeholder='Abdomen-pelvis'
                                                options={option_normal_abnormal}
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}
                                                error={inputText.abdomen_pelvis}
                                            />
                                            <Form.Select

                                                fluid label='Extremities'
                                                name='extremities'
                                                value={input.extremities}
                                                placeholder='Extremities'
                                                options={option_normal_abnormal}
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}
                                                error={inputText.extremities}
                                            />
                                            <Form.Select
                                                fluid label='Per-rectal exam'
                                                name='per_rectal_exam'
                                                value={input.per_rectal_exam}
                                                placeholder='Per-rectal exam'
                                                options={option_normal_abnormal}
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}
                                                error={inputText.per_rectal_exam}
                                            />
                                            <Form.Select

                                                fluid label='Neurologic'
                                                name='neurologic'
                                                value={input.neurologic}
                                                placeholder='Neurologic'
                                                options={option_normal_abnormal}
                                                required={'true'}
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                error={inputText.neurologic}
                                            />
                                        </Form.Group>

                                        <Form.Group widths='equal'
                                                    style={{display: (input.head_neck === 'Abnormal' ? '' : 'none')}}>

                                            <Form.TextArea
                                                fluid
                                                label={(<label style={{color: '#a5673f'}}>Head - neck Remark </label>)}
                                                name='head_neck_remark'
                                                value={input.head_neck_remark}
                                                placeholder='Head - neck Remark '
                                                onChange={(e) => handleValueChange(e)}
                                            />
                                        </Form.Group>
                                        <Form.Group widths='equal'
                                                    style={{display: (input.heart_lungs === 'Abnormal' ? '' : 'none')}}>
                                            <Form.TextArea
                                                fluid
                                                label={(<label style={{color: '#a5673f'}}>Head - lungs Remark </label>)}
                                                name='heart_lungs_remark'
                                                value={input.heart_lungs_remark}
                                                placeholder='Heart - lungs Remark '
                                                onChange={(e) => handleValueChange(e)}
                                            />
                                        </Form.Group>
                                        <Form.Group widths='equal'
                                                    style={{display: (input.abdomen_pelvis === 'Abnormal' ? '' : 'none')}}>
                                            <Form.TextArea
                                                fluid
                                                label={(<label style={{color: '#a5673f'}}>Abdomen-pelvis Remarkn</label>)}
                                                name='abdomen_pelvis_remark'
                                                value={input.abdomen_pelvis_remark}
                                                placeholder='Abdomen-pelvis Remark'
                                                onChange={(e) => handleValueChange(e)}
                                            />
                                        </Form.Group>
                                        <Form.Group widths='equal'
                                                    style={{display: (input.extremities === 'Abnormal' ? '' : 'none')}}>
                                            <Form.TextArea
                                                fluid label={(<label style={{color: '#a5673f'}}>Extremities </label>)}
                                                name='extremities_remark'
                                                value={input.extremities_remark}
                                                placeholder='Extremities'
                                                onChange={(e) => handleValueChange(e)}
                                            />
                                        </Form.Group>
                                        <Form.Group widths='equal'
                                                    style={{display: (input.per_rectal_exam === 'Abnormal' ? '' : 'none')}}>
                                            <Form.TextArea
                                                fluid
                                                label={(<label style={{color: '#a5673f'}}>Per-rectal exam Remark</label>)}
                                                name='per_rectal_exam_remark'
                                                value={input.per_rectal_exam_remark}
                                                placeholder='Per-rectal exam Remark'
                                                onChange={(e) => handleValueChange(e)}
                                            />
                                        </Form.Group>
                                        <Form.Group widths='equal'
                                                    style={{display: (input.neurologic === 'Abnormal' ? '' : 'none')}}>
                                            <Form.TextArea
                                                fluid label={(<label style={{color: '#a5673f'}}>Neurologic Remark </label>)}
                                                name='neurologic_remark'
                                                value={input.neurologic_remark}
                                                placeholder='Neurologic Remark'
                                                onChange={(e) => handleValueChange(e)}
                                            />
                                        </Form.Group>

                                        <Form.TextArea

                                            fluid label='Investigations'
                                            name='investigations'
                                            value={input.investigations}
                                            placeholder='Investigations'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                        <Header as='h3' color='blue' dividing>
                                            Diagnosis
                                        </Header>

                                        <Form.Group widths='equal'>
                                            <Form.TextArea

                                                fluid label='Admission diagnosis'
                                                name='primary_diagnosis'
                                                value={input.primary_diagnosis}
                                                placeholder='Admission diagnosis'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.primary_diagnosis}
                                            />
                                            <Form.TextArea

                                                fluid label='Other problems'
                                                name='other_problems'
                                                value={input.other_problems}
                                                placeholder='None'
                                                onChange={(e) => handleValueChange(e)}
                                            />
                                        </Form.Group>
                                        <Form.TextArea

                                            fluid label='Plan of managements'
                                            name='plan_of_managements'
                                            value={input.plan_of_managements}
                                            placeholder='Plan of managements'
                                            onChange={(e) => handleValueChange(e)}
                                            required={'true'}
                                            error={inputText.plan_of_managements}
                                        />
                                        <Header as='h3' dividing color='blue'>
                                            Record information
                                        </Header>
                                        <Form.Group widths='equal'>
                                            <Form.Input

                                                fluid label='Ward'
                                                name='ward'
                                                value={input.ward}
                                                placeholder='ward'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.ward}
                                            />
                                            <Form.Select

                                                fluid label='Staff'
                                                name='staff_id'
                                                value={input.staff_id}
                                                options={staff}
                                                placeholder='Staff'
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}
                                                error={inputText.staff_id}
                                            />

                                            <Form.Input

                                                fluid label='Resident'
                                                name='resident_name'
                                                value={input.resident_name}
                                                placeholder='Resident'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.resident_name}
                                            />
                                            <Form.Input

                                                fluid label='Division'
                                                name='division'
                                                value={input.division}
                                                placeholder='division'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                disabled={true}
                                            />

                                        </Form.Group>
                                        <Form.Group widths='equal'>
                                            <Form.Input

                                                fluid label='ผู้บันทึก'
                                                name='record_name'
                                                value={input.record_name}
                                                placeholder='ผู้บันทึก'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.record_name}
                                            />
                                            <Form.Input

                                                fluid label='รหัสผู้บันทึก'
                                                name='recode_code'
                                                value={input.recode_code}
                                                placeholder='รหัสผู้บันทึก ex.SU63999'
                                                onChange={(e) => handleValueChange(e)}
                                                required={'true'}
                                                error={inputText.recode_code}
                                            />

                                            <Form.Input

                                                fluid label='วันเวลาที่บันทึก'
                                                name='record_datetime'
                                                value={input.record_datetime}
                                                placeholder='วันเวลาที่บันทึก'
                                                onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                                required={'true'}
                                                disabled={true}
                                            />

                                        </Form.Group>
                                        <Form.Button color='blue'
                                                     onClick={() => saveAdmission()}
                                        ><Icon name='plus'/> บันทึก Admission note</Form.Button>


                                    </Form>
                                </Segment>

                            </Grid.Column>
                        </Grid.Row>

                    </Grid>
                </div>
                <Modal
                    centered={false}
                    open={open}
                    onClose={() => setOpen(false)}
                    onOpen={() => setOpen(true)}
                    style={{height: 'auto', left: 'auto'}}

                >
                    <Modal.Header>{inputText.text_head}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            {inputText.text_description}
                        </Modal.Description>
                        {
                            inputText.text_error.length > 0 && inputText.text_error.map((v, i) => (
                                <Modal.Description key={i}><b style={{color: 'red'}}>{v}</b></Modal.Description>
                            ))
                        }
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => setOpen(false)}>OK</Button>
                    </Modal.Actions>
                </Modal>
            </div>
        </>
    );
}

export default Admission;
